import { Injectable } from '@angular/core';
import { FormControl, FormGroup, FormArray } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class FormUtilService {

  /**
   * Force validation on form group.
   *
   * @param formGroup to be validated
   */
  public static validateForm(formGroup: FormGroup): boolean {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {
        return FormUtilService.validateForm(control);
      } else if (control instanceof FormArray) {
        if (control.controls[0] && control.controls[0] instanceof FormControl) {
          control.controls.forEach((subControl: FormControl) => subControl.markAsTouched({onlySelf: true}));
        } else {
          control.controls.forEach((group: FormGroup) => FormUtilService.validateForm(group));
        }
      }
    });
    formGroup.markAsTouched({onlySelf: true});
    return formGroup.valid;
  }
}
